import { Injectable } from '@angular/core';
import { Validators, AbstractControl, FormControl } from '@angular/forms';
import { AppMessages } from '../constants/messages';
import { AppConstants } from '../constants/constants';
import { Utility } from '../../common/utility';

@Injectable()
export class ValidationService {

  constructor() {
  }

  public static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    let errorMessage = AppMessages.errors;
    if (validatorName === 'required') {
      return Utility.stringFormat(errorMessage[validatorName], [validatorValue]);
    }
    return errorMessage[validatorName];
  }

  public static attachRequired(formControl, validators) {
    validators.unshift(Validators.required); // push validator at first place in array*/
    formControl.setValidators(validators);
    if (formControl.value === '') {
      formControl.setErrors({ "required": true });
    }

  }

  public static removeRequired(formControl, validators) {
    formControl.setValidators(validators);
    if (formControl.errors && formControl.errors.hasOwnProperty('required')) {
      formControl.setErrors(null);
    }
  }

  public static attachValidators(formControl, validators) {
    if (!validators) {
      validators.unshift(Validators.required); // push validator at first place in array*!/
    }
    formControl.setValidators(validators);
    formControl.setErrors(formControl.validator(validators));
  }

  public static removeValidators(formControl) {
    formControl.clearValidators(null);
    formControl.setErrors(null);
  }


  public static isValidEmail(formControl) {
    let pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (formControl.value && !pattern.test(formControl.value)) {
      return { 'invalidEmail': true };
    }
    return null;
  }

  public static isValidDate(formControl) {
    const date = formControl.value;
    if (!date || Object.prototype.toString.call(date) !== "[object Date]" || isNaN(date.getTime())) {
      return { 'invalidDate': true };
    }
    /* if (!date || date === "") {
       return  { 'required': true };
     } else if ((date && Object.prototype.toString.call(date) !== "[object Date]" || isNaN( date.getTime() ))) {
       return { 'invalidDate': true };
     }*/
    return null;
  }

  /**
   * Format the input follow date string format and set error for formControl if date is invalid
   * @param FormControl formControl
   * @param Event event : input target
   */
  public static validationDate(formControl, event) {
    let date = formControl.value;
    if (date) {
      event.targetElement.value = Utility.formatDate(date);
    } else {
      let dateControl = new FormControl({ value: event.targetElement.value });
      if (event.targetElement.value !== "") {
        formControl.setErrors(ValidationService.isValidDate(dateControl));
      }
    }
  }

  /**
   * Remove required error when input date is invalid
   * @param FormControl formControl
   * @param Event event : input target
   */
  public static removeRequiredError(formControl, event) {
    if (formControl.errors && formControl.errors.hasOwnProperty('required') &&  event.targetElement.value != "") {
      delete formControl.errors["required"];
    }
  }

  /**
   * Compare two dates (could be of any type supported by the convert
   * @param Date object fromDate
   * @param Date object toDate
   * function returns:
   *  -1 : if a < b
   *   0 : if a = b
   *   1 : if a > b
   *  null : if a or b is an illegal date
   */

  public static compareDate(fromDate, toDate) {
    if (ValidationService.isValidDate(fromDate) || ValidationService.isValidDate(toDate)) {
      return null;
    }
    //fromDate.value.setHours(0, 0, 0, 0);
    //toDate.value.setHours(0, 0, 0, 0);
    let from = fromDate.value.getTime();
    let to = toDate.value.getTime();
    if (from > to) {
      return 1;
    } else if (from < to) {
      return -1;
    }
    return 0;
  }

  /** Validation when user input Date of birth : date of birth must be lower than current date
  * @param: FromCOntrol
  */
  public static isValidDateOfBirth(formControl) {
    let selectedDate = formControl.value;
    let currenDateOfBirth = new Date();

    if (selectedDate > currenDateOfBirth) {
      return { 'invalidDateOfBirth': true };
    }
    return null;
  }

  public static isValidMinLength(formControl) {
    const minLength = AppConstants.formConfig.textBox.minLength;
    if (formControl.value.length < minLength) {
      return { 'invalidMinLength': true };
    }
    return null;
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/validation.service.ts